import axios from 'axios';
import store from '@/store';
import router from '@/router';
import qs from 'qs';
import ls from 'local-storage';

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '/api', // api base_url
    timeout: 10 * 60 * 1000, // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        // api formatt
        // if (!config.url.endsWith('.json')) {
        //     config.url += '.json';
        // }
        if (config.data && config.formData != false) {
            config.data = qs.stringify(config.data);
        }
        config.headers.uvsign = store.state.sign || ls.get('sign') || '';
        config.headers.dataSource = 4;

        return config;
    },
    (error) => {
        // Do something with request error
        Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    (res) => {
        // const { data, errmsg } = res.data;
        // const responseData = {
        //     msg: errmsg,
        //     result: data
        // }
        // res.data = {...res.data,...responseData}
        //Vue.set(res.data,'state',res.data.code == 200 ? true : false);

        // Stream file
        if (res.request.responseType === 'blob' && res.data instanceof Blob) {
            return res;
        }

        // Not login
        const failState = ['token.empty', 'not.login', 'notlogin', 'depart'];
        const path = router.currentRoute.path;
        const fullPath = router.currentRoute.fullPath;
        const {code} = res.data;
        if (failState.includes(code) && path !== '/login') {
            store.commit('LOGOUT');
            // 验证是否是移交管理员被登出
            let url = '/login';
            router.replace({
                path: url,
                query: {redirect: fullPath},
            });
        }
        return res;
    },
    (error) => {
        // 产品要求这样的提示
        if (error.code === 'ECONNABORTED') {
            error.message = '你当前的网速堪忧!';
        }
        return Promise.reject(error);
    }
);

export default service;
